export const togglePassword = () => {
  const x: any = document.getElementById('passwordInput');
  if (x.type === 'password') {
    x.type = 'text';
  } else {
    x.type = 'password';
  }
};
